import { ReactNode, createContext } from "react";
import useTipoAgenda, { TipoAgendaType, CreateTipoAgendaType, UpdateTipoAgendaType } from "./hooks/useTipoAgenda";

interface TipoAgendaContextProviderProps {
    children: ReactNode;
}

export interface TipoAgendaContextData {
    getAllTipoAgendaPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<TipoAgendaType[] | null>;
    setTipoAgenda: any;
    tipoAgenda: TipoAgendaType;
    setListTipoAgenda: any;
    listTipoAgenda: TipoAgendaType[];
    setInitialListTipoAgenda: any;
    initialListTipoAgenda: TipoAgendaType[];
    setAgendaPageCount: any;
    agendaPageCount: number;
    createTipoAgenda: (createTipoAgendaType: CreateTipoAgendaType) => Promise<CreateTipoAgendaType | null>;
    updateTipoAgenda: (updateTipoAgendaType: UpdateTipoAgendaType) => Promise<UpdateTipoAgendaType | null>;
    deleteTipoAgenda: (id: number) => Promise<TipoAgendaType | null>;
}

const initialState: TipoAgendaContextData = {
    getAllTipoAgendaPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setTipoAgenda: () => { },
    tipoAgenda: {
        id: 0,
        description: "",
        empresaId: 0,
    },
    setListTipoAgenda: () => {},
    listTipoAgenda: [],
    setInitialListTipoAgenda: () => {},
    initialListTipoAgenda: [],
    setAgendaPageCount: () => {},
    agendaPageCount: 0,
    createTipoAgenda: async (createTipoAgendaType: CreateTipoAgendaType) => {
        return Promise.resolve(null);
    },
    updateTipoAgenda: async (updateTipoAgendaType: UpdateTipoAgendaType) => {
        return Promise.resolve(null);
    },
    deleteTipoAgenda: async (id: number) => {
        return Promise.resolve(null);
    },
};

export const TipoAgendaContext =
    createContext<TipoAgendaContextData>(initialState);

export default function TipoAgendaContextProvider({
    children,
}: TipoAgendaContextProviderProps) {
    const {
        getAllTipoAgendaPaged,
        createTipoAgenda,
        updateTipoAgenda,
        deleteTipoAgenda,
        tipoAgenda,
        setTipoAgenda,
        setListTipoAgenda,
        listTipoAgenda,
        initialListTipoAgenda,
        setInitialListTipoAgenda,
        setAgendaPageCount,
        agendaPageCount,
    } = useTipoAgenda();

    return (
        <TipoAgendaContext.Provider
            value={{
                getAllTipoAgendaPaged,
                createTipoAgenda,
                updateTipoAgenda,
                deleteTipoAgenda,
                tipoAgenda,
                setTipoAgenda,
                setListTipoAgenda,
                listTipoAgenda,
                initialListTipoAgenda,
                setInitialListTipoAgenda,
                setAgendaPageCount,
                agendaPageCount,
            }}
        >
            {children}
        </TipoAgendaContext.Provider>
    );
}